import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from "./components/LandingPage";
import AdminDashboard from "./components/admin/AdminDashboardNew";
import AdminLoginPage from "./components/admin/AdminLoginPage";
import TimeCodePage from "./components/TimeCodePage";

function App() {
  // Dynamically detect if we're running under /waermepumpen path
  const currentPath = window.location.pathname;
  const isReverseProxyPath = currentPath.startsWith('/waermepumpen');
  const basename = isReverseProxyPath ? '/waermepumpen' : '';

  console.log('App.js - Current path:', currentPath);
  console.log('App.js - Is reverse proxy:', isReverseProxyPath);
  console.log('App.js - Basename:', basename);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter basename={basename}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/uhr" element={<TimeCodePage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
